import React from 'react';
import UserTable from './UserTable';

const UserRoleSection = ({ 
  titulo, 
  usuarios, 
  color, 
  usuariosConectados, 
  permisoModeracion, 
  toggleAcciones, 
  accionesUsuario, 
  setAccionMenu,
  handleActualizarRol, 
  confirmarAccion,
  onUserClick
}) => {
  if (usuarios.length === 0) return null;

  return (
    <div>
      <h4 className="text-xl font-semibold mb-4" style={{ color }}>{titulo}</h4>
      <UserTable
        usuarios={usuarios}
        usuariosConectados={usuariosConectados}
        permisoModeracion={permisoModeracion}
        toggleAcciones={toggleAcciones}
        accionesUsuario={accionesUsuario}
        setAccionMenu={setAccionMenu}
        handleActualizarRol={handleActualizarRol}
        confirmarAccion={confirmarAccion}
        onUserClick={onUserClick}
      />
    </div>
  );
};

export default UserRoleSection;
